import { useOrderFulfillment } from 'src/Components/Header/modules/Menu/hooks/useOrderFullfilment';
import { useMemo } from 'react';
import { useAppRouting } from 'src/Hooks/useAppRouting';
import { useSelector } from 'react-redux';
import { salesPageSelectors } from 'src/Pages/Sales/services';
import { globalSelectors } from 'src/Redux/Global/selectors';
import { useLocalization } from 'src/Hooks';
import { TermsOfPaymentType } from 'src/Enums';
import { localizationUtils } from 'src/Utils/localizationUtils';
import { paymentStatusUtils } from '@/Utils/models/PaymentStatus';

export const useChangeDeliveryStatus = () => {
  const {
    menu: { Tooltips },
  } = useLocalization();

  const { isSalesPage } = useAppRouting();
  const { changeOrderStatusProps } = useOrderFulfillment();
  const localization = useSelector(globalSelectors.localization);
  const selectedSales = useSelector(salesPageSelectors.selectedSales);

  const changeDeliveryStatusProps = useMemo((): { message: string; isDisabled: boolean } => {
    const deliveryNotRequired = selectedSales.some((item) => !item.isDeliveryRequired);

    if (deliveryNotRequired) {
      return {
        isDisabled: true,
        message: Tooltips.DeliveryNotRequired.Message,
      };
    }

    // Using default errors
    if (changeOrderStatusProps.isDocumentIconDisabled) {
      return {
        isDisabled: true,
        message: changeOrderStatusProps.disabledDocumentMessage,
      };
    }

    if (!isSalesPage) {
      return {
        isDisabled: false,
        message: '',
      };
    }

    const notPostpaidNotPaidOrders = selectedSales
      .filter((x) => {
        return x.termsOfPayment !== TermsOfPaymentType.Postpaid && !paymentStatusUtils.isOrderPaid(x.paymentStatus);
      })
      .map((x) => x.userOrderId);

    if (notPostpaidNotPaidOrders.length) {
      return {
        isDisabled: true,
        message: localizationUtils.insertTranslatedParamsToString(
          Tooltips.ChangeDeliveryStatusNotPostpaidNotPaid.Message,
          [notPostpaidNotPaidOrders.length, notPostpaidNotPaidOrders.join(', ')],
          Tooltips.parts,
          localization,
        ),
      };
    }

    return { message: '', isDisabled: false };
  }, [changeOrderStatusProps, selectedSales, isSalesPage, Tooltips, localization]);

  return {
    isChangeDeliveryStatusDisabled: changeDeliveryStatusProps.isDisabled,
    changeDeliveryStatusDisabledMessage: changeDeliveryStatusProps.message,
  };
};
